





















































































































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import { EventBus } from "@/eventbus";
export default Vue.extend({
  props: ["source"],
  components: {
    AppTableRow,
    SensitivityLabel,
  },
  setup(props) {
    const onLevelClicked = (severity: number, count: number) => {
      EventBus.emit("show-events", {
        // @ts-ignore
        id: props.source.id,
        severity,
        count,
      });
    };
    const showMenu = (event: MouseEvent) =>
      EventBus.emit("show-menu", { item: props.source, event });
    return {
      onLevelClicked,
      showMenu,
    };
  },
});
